<template>
  <div class="order-detail">
    <div class="order-section">订单信息</div>
    <div class="order-info">
      <div class="order-info_item">
        <span class="order-info_label">订单编号：</span>
        <span class="order-info_value">{{ detail.order_number }}</span>
      </div>
      <div class="order-info_item">
        <span class="order-info_label">手机号码：</span>
        <span class="order-info_value">{{ detail.mobile }}</span>
      </div>
      <div class="order-info_item">
        <span class="order-info_label">下单时间：</span>
        <span class="order-info_value">
          {{ detail.created_at | tsFormatLong }}
        </span>
      </div>
      <div class="order-info_item">
        <span class="order-info_label">支付渠道：</span>
        <span class="order-info_value" v-if="detail.pay_type > 0">
          {{ detail.pay_type | payType }}
        </span>
        <span class="order-info_value" v-else-if="detail.pay_status == 2">
          线上支付
        </span>
        <span class="order-info_value" v-else>--</span>
      </div>
      <div class="order-info_item">
        <span class="order-info_label">订单状态：</span>
        <span class="order-info_value">{{ detail.status_name }}</span>
      </div>
      <div class="order-info_item">
        <span class="order-info_label">支付时间：</span>
        <span class="order-info_value" v-if="detail.pay_time == 0">--</span>
        <span class="order-info_value" v-else>
          {{ detail.pay_time | tsFormatLong }}
        </span>
      </div>
    </div>
    <template v-if="detail.ship_status != 2 && detail.address_info">
      <div class="order-section">
        收货信息
        <p class="address-box" @click="onOpenAdress">修改地址</p>
      </div>
      <div class="order-info">
        <div class="order-info_item">
          <span class="order-info_label">收货人姓名：</span>
          <span class="order-info_value">
            {{ detail.address_info.consignee }}
          </span>
        </div>
        <div class="order-info_item">
          <span class="order-info_label">手机号码：</span>
          <span class="order-info_value">
            {{ detail.address_info.consignee_mobile }}
          </span>
        </div>
        <div class="order-info_item">
          <span class="order-info_label">详细地址：</span>
          <span class="order-info_value">
            {{
              detail.address_info.province_name +
              detail.address_info.city_name +
              detail.address_info.district_name +
              detail.address_info.address
            }}
          </span>
        </div>
      </div>
    </template>
    <template v-if="!!detail.logistics_info.length">
      <div class="order-section">物流信息</div>
      <MemberOrderLogistics
        :logistics="detail.logistics_info"
      ></MemberOrderLogistics>
    </template>
    <div class="order-section">商品明细</div>
    <MemberOrderGoods :detail="detail" :current="current"></MemberOrderGoods>
    <div style="margin-top: 32px">
      <div class="clearfix">
        <div class="f-right detail-item-right">
          <div class="detail-item flex-row">
            <label>
              {{ current == 6 || current == 1 ? "商品金额：" : "合计：" }}
            </label>
            <span class="flex-row">
              <span class="jianhao"></span>
              <Currency class="currency"></Currency>
              <span>{{ detail.original_price | price }}</span>
            </span>
          </div>
          <div
            class="detail-item flex-row"
            v-if="detail.items && detail.items[0].shop_type == 12"
          >
            <label>运费：</label>
            <span class="flex-row">
              <span class="jianhao"></span>
              <Currency class="currency"></Currency>
              <span>{{ detail.ship_price | price }}</span>
            </span>
          </div>
          <div v-if="detail.order_type == 7" class="detail-item flex-row">
            <label>联报优惠：</label>
            <span class="flex-row">
              <span class="jianhao"></span>
              -
              <Currency class="currency"></Currency>
              <span>{{ detail.other_discount | price }}</span>
            </span>
          </div>
          <div
            class="detail-item flex-row"
            v-if="
              $store.state.commonSetting.switch_coupon_module === 1 &&
              current != 6 &&
              current != 9 &&
              current != 10
            "
          >
            <label>优惠券：</label>
            <span class="flex-row">
              <span class="jianhao">-</span>
              <Currency class="currency"></Currency>
              <span>{{ detail.coupon_discount | price }}</span>
            </span>
          </div>
          <div
            class="detail-item flex-row"
            v-if="$store.getters.showVip && current == 10"
          >
            <label>会员优惠：</label>
            <span class="flex-row">
              <span class="jianhao">-</span>
              <Currency class="currency"></Currency>
              <span>{{ detail.vip_discount | price }}</span>
            </span>
          </div>
          <div class="detail-item flex-row order-item">
            <label>{{ detail.pay_status == 1 ? "应付" : "实付" }}金额：</label>
            <span class="flex-row">
              <span class="jianhao"></span>
              <Currency class="currency"></Currency>
              <span>
                {{ (detail.order_price + detail.ship_price) | price }}
              </span>
            </span>
          </div>
          <div
            v-if="detail.refund_price"
            class="detail-item flex-row order-item"
          >
            <label>退款金额：</label>
            <span class="flex-row">
              <span class="jianhao"></span>
              <Currency class="currency"></Currency>
              <span>
                {{ detail.refund_price | price }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <AddressForm
      ref="form"
      title="修改地址"
      tip="此地址只用于邮寄实体教材，请准确填写"
      @success="chanageSuccess"
      :onConfirm="changeAddress"
      :address="addressInfo"
    ></AddressForm>
  </div>
</template>
<script>
import orderFuc from "@/utils/order.js";
import MemberOrderGoods from "./components/MemberOrderGoods.vue";
import MemberOrderLogistics from "./components/MemberOrderLogistics.vue";
import AddressForm from "../../components/AddressForm.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";

export default {
  name: "MemberOrderDetail",
  components: { MemberOrderGoods, MemberOrderLogistics, AddressForm },
  data() {
    return {
      id: this.$route.params.id,
      current: this.$route.query.current,
      detail: {
        logistics_info: [],
      },
      addressInfo: null,
    };
  },
  async created() {
    await this.getDetail();
    triggerLoaded(this);
  },
  methods: {
    async getDetail() {
      let data = await this.$http.post("/api/app/myOrder/detail", {
        order_id: this.id,
      });
      // data.group_status = data.group_info.group_status;
      // data.join_num = data.group_info.join_num;
      // data.user_num = data.group_info.user_num;
      data.status_name = this.getStatusName(data);
      this.detail = data;
    },
    getStatusName(order) {
      let text = orderFuc.getListDescData(order).text;
      return text ? text.list : "";
    },
    async onOpenAdress() {
      let address = await this.$http.get(
        `/api/app/address/${this.detail.address_id}`,
      );
      address.orderId = this.id;
      this.addressInfo = address;
      this.$refs.form.showForm();
    },
    changeAddress(params) {
      return new Promise(async resolve => {
        await this.$http.put(
          `/api/app/myOrder/address/modify/${this.id}`,
          params,
        );
        resolve();
      });
    },
    chanageSuccess() {
      this.$message.success("修改地址成功");
      this.getDetail();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../css/member-order.scss";
.order-detail {
  padding: 20px 24px 23px 24px;
  background: #fff;
  border-radius: 6px;
}
.order-section {
  position: relative;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  margin-bottom: 20px;
  &::before {
    content: "";
    position: absolute;
    width: 3px;
    height: 18px;
    opacity: 1;
    background: #fabc1d;
    top: 2px;
    left: -8px;
  }
  .address-box {
    position: absolute;
    right: 0;
    top: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: $primary-color;
    padding-left: 18px;
    cursor: pointer;
    background: url("~@stu/images/member/icon-order-detail-address.png")
      no-repeat 0 center;
    background-size: 14px 14px;
  }
}
.order-info {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.order-info_item {
  width: calc(100% / 3);
  margin-bottom: 8px;
  display: flex;
}
.order-info_label {
  color: #999;
}
</style>
